import { BrowserRouter, Route, Routes } from "react-router";
import { RequireAuth } from "./components/RequireAuth";
import { AuthProvider } from "./lib/auth";
import { AccountSettings } from "./routes/AccountSettings";
import { CameraView } from "./routes/CameraView";
import { DesignSystem } from "./routes/DesignSystem/DesignSystem";
import { Home } from "./routes/Home";
import { Login } from "./routes/Login";
import { NvrView } from "./routes/NvrView";
import { Recover } from "./routes/Recover";
import { Register } from "./routes/Register";
import { SetupWizard } from "./routes/SetupWizard";
import { Shopping } from "./routes/Shopping";
import { StoreDetail, StoreSettingsRedirect } from "./routes/StoreDetail";
import { StoresList } from "./routes/Stores";

const guarded = (element: React.ReactNode) => <RequireAuth>{element}</RequireAuth>;

export const App = () => (
  <BrowserRouter>
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/recover" element={<Recover />} />
        <Route path="/account" element={guarded(<AccountSettings />)} />
        <Route path="/shopping" element={guarded(<Shopping />)} />
        <Route path="/stores" element={guarded(<StoresList />)} />
        <Route path="/stores/new" element={guarded(<SetupWizard />)} />
        <Route path="/stores/:storeId/setup" element={guarded(<SetupWizard />)} />
        <Route path="/stores/:storeId" element={guarded(<StoreDetail />)} />
        <Route path="/stores/:storeId/settings" element={guarded(<StoreSettingsRedirect />)} />
        <Route path="/cameras/:cameraId" element={guarded(<CameraView />)} />
        <Route path="/nvrs/:nvrId" element={guarded(<NvrView />)} />
        <Route path="/ds" element={<DesignSystem />} />
      </Routes>
    </AuthProvider>
  </BrowserRouter>
);
